// models/constants.ts

export const stateOptions = [
  { name: 'Johor', value: 'Johor' },
  { name: 'Kedah', value: 'Kedah' },
  { name: 'Kelantan', value: 'Kelantan' },
  { name: 'Melaka', value: 'Melaka' },
  { name: 'Negeri Sembilan', value: 'Negeri Sembilan' },
  { name: 'Pahang', value: 'Pahang' },
  { name: 'Pulau Pinang', value: 'Pulau Pinang' },
  { name: 'Perak', value: 'Perak' },
  { name: 'Perlis', value: 'Perlis' },
  { name: 'Selangor', value: 'Selangor' },
  { name: 'Terengganu', value: 'Terengganu' },
  { name: 'Sabah', value: 'Sabah' },
  { name: 'Sarawak', value: 'Sarawak' },
  {
    name: 'Wilayah Persekutuan Kuala Lumpur',
    value: 'Wilayah Persekutuan Kuala Lumpur',
  },
  { name: 'Wilayah Persekutuan Labuan', value: 'Wilayah Persekutuan Labuan' },
  {
    name: 'Wilayah Persekutuan Putrajaya',
    value: 'Wilayah Persekutuan Putrajaya',
  },
  { name: 'Not Applicable', value: 'Not Applicable' },
];

export const countryOptions = [
  { name: 'Aruba', value: 'Aruba' },
  { name: 'Afghanistan', value: 'Afghanistan' },
  { name: 'Angola', value: 'Angola' },
  { name: 'Anguilla', value: 'Anguilla' },
  { name: 'Aland Islands', value: 'Aland Islands' },
  { name: 'Albania', value: 'Albania' },
  { name: 'Andorra', value: 'Andorra' },
  { name: 'Netherlands Antilles', value: 'Netherlands Antilles' },
  { name: 'United Arab Emirates', value: 'United Arab Emirates' },
  { name: 'Argentina', value: 'Argentina' },
  { name: 'Armenia', value: 'Armenia' },
  { name: 'American Samoa', value: 'American Samoa' },
  { name: 'Antarctica', value: 'Antarctica' },
  { name: 'French Southern Territories', value: 'French Southern Territories' },
  { name: 'Antigua And Barbuda', value: 'Antigua And Barbuda' },
  { name: 'Australia', value: 'Australia' },
  { name: 'Austria', value: 'Austria' },
  { name: 'Azerbaijan', value: 'Azerbaijan' },
  { name: 'Burundi', value: 'Burundi' },
  { name: 'Belgium', value: 'Belgium' },
  { name: 'Benin', value: 'Benin' },
  {
    name: 'Bonaire, Sint Eustatius And Saba',
    value: 'Bonaire, Sint Eustatius And Saba',
  },
  { name: 'Burkina Faso', value: 'Burkina Faso' },
  { name: 'Bangladesh', value: 'Bangladesh' },
  { name: 'Bulgaria', value: 'Bulgaria' },
  { name: 'Bahrain', value: 'Bahrain' },
  { name: 'Bahamas', value: 'Bahamas' },
  { name: 'Bosnia And Herzegovina', value: 'Bosnia And Herzegovina' },
  { name: 'Saint Barthelemy', value: 'Saint Barthelemy' },
  { name: 'Belarus', value: 'Belarus' },
  { name: 'Belize', value: 'Belize' },
  { name: 'Bermuda', value: 'Bermuda' },
  { name: 'Bolivia', value: 'Bolivia' },
  { name: 'Brazil', value: 'Brazil' },
  { name: 'Barbados', value: 'Barbados' },
  { name: 'Brunei Darussalam', value: 'Brunei Darussalam' },
  { name: 'Bhutan', value: 'Bhutan' },
  { name: 'Bouvet Island', value: 'Bouvet Island' },
  { name: 'Botswana', value: 'Botswana' },
  { name: 'Central African Republic', value: 'Central African Republic' },
  { name: 'Canada', value: 'Canada' },
  { name: 'Cocos Island', value: 'Cocos Island' },
  { name: 'Switzerland', value: 'Switzerland' },
  { name: 'Chile', value: 'Chile' },
  { name: 'China', value: 'China' },
  { name: 'Cote D’Ivoire', value: 'Cote D’Ivoire' },
  { name: 'Cameroon', value: 'Cameroon' },
  {
    name: 'Congo, The Democratic Republic',
    value: 'Congo, The Democratic Republic',
  },
  { name: 'Congo', value: 'Congo' },
  { name: 'Cook Islands', value: 'Cook Islands' },
  { name: 'Colombia', value: 'Colombia' },
  { name: 'Comoros', value: 'Comoros' },
  { name: 'Cape Verde', value: 'Cape Verde' },
  { name: 'Costa Rica', value: 'Costa Rica' },
  { name: 'Cuba', value: 'Cuba' },
  { name: 'Curacao', value: 'Curacao' },
  { name: 'Christmas Islands', value: 'Christmas Islands' },
  { name: 'Cayman Islands', value: 'Cayman Islands' },
  { name: 'Cyprus', value: 'Cyprus' },
  { name: 'Czech Republic', value: 'Czech Republic' },
  { name: 'Germany', value: 'Germany' },
  { name: 'Djibouti', value: 'Djibouti' },
  { name: 'Dominica', value: 'Dominica' },
  { name: 'Denmark', value: 'Denmark' },
  { name: 'Dominican Republic', value: 'Dominican Republic' },
  { name: 'Algeria', value: 'Algeria' },
  { name: 'Ecuador', value: 'Ecuador' },
  { name: 'Egypt', value: 'Egypt' },
  { name: 'Eritrea', value: 'Eritrea' },
  { name: 'Western Sahara', value: 'Western Sahara' },
  { name: 'Spain', value: 'Spain' },
  { name: 'Estonia', value: 'Estonia' },
  { name: 'Ethiopia', value: 'Ethiopia' },
  { name: 'Finland', value: 'Finland' },
  { name: 'Fiji', value: 'Fiji' },
  { name: 'Falkland Islands (Malvinas)', value: 'Falkland Islands (Malvinas)' },
  { name: 'France', value: 'France' },
  { name: 'Faeroe Islands', value: 'Faeroe Islands' },
  {
    name: 'Micronesia, Federated States Of',
    value: 'Micronesia, Federated States Of',
  },
  { name: 'Gabon', value: 'Gabon' },
  { name: 'United Kingdom', value: 'United Kingdom' },
  { name: 'Georgia', value: 'Georgia' },
  { name: 'Guernsey', value: 'Guernsey' },
  { name: 'Ghana', value: 'Ghana' },
  { name: 'Gibraltar', value: 'Gibraltar' },
  { name: 'Guinea', value: 'Guinea' },
  { name: 'Guadeloupe', value: 'Guadeloupe' },
  { name: 'Gambia', value: 'Gambia' },
  { name: 'Guinea-Bissau', value: 'Guinea-Bissau' },
  { name: 'Equatorial Guinea', value: 'Equatorial Guinea' },
  { name: 'Greece', value: 'Greece' },
  { name: 'Grenada', value: 'Grenada' },
  { name: 'Greenland', value: 'Greenland' },
  { name: 'Guatemala', value: 'Guatemala' },
  { name: 'French Guiana', value: 'French Guiana' },
  { name: 'Guam', value: 'Guam' },
  { name: 'Guyana', value: 'Guyana' },
  { name: 'Hong Kong', value: 'Hong Kong' },
  { name: 'Heard And Mcdonald Islands', value: 'Heard And Mcdonald Islands' },
  { name: 'Honduras', value: 'Honduras' },
  { name: 'Croatia', value: 'Croatia' },
  { name: 'Haiti', value: 'Haiti' },
  { name: 'Hungary', value: 'Hungary' },
  { name: 'Indonesia', value: 'Indonesia' },
  { name: 'Isle Of Man', value: 'Isle Of Man' },
  { name: 'India', value: 'India' },
  {
    name: 'British Indian Ocean Territory',
    value: 'British Indian Ocean Territory',
  },
  { name: 'Ireland', value: 'Ireland' },
  { name: 'Iran', value: 'Iran' },
  { name: 'Iraq', value: 'Iraq' },
  { name: 'Iceland', value: 'Iceland' },
  { name: 'Israel', value: 'Israel' },
  { name: 'Italy', value: 'Italy' },
  { name: 'Jamaica', value: 'Jamaica' },
  { name: 'Jersey (Channel Islands)', value: 'Jersey (Channel Islands)' },
  { name: 'Jordan', value: 'Jordan' },
  { name: 'Japan', value: 'Japan' },
  { name: 'Kazakhstan', value: 'Kazakhstan' },
  { name: 'Kenya', value: 'Kenya' },
  { name: 'Kyrgyzstan', value: 'Kyrgyzstan' },
  { name: 'Cambodia', value: 'Cambodia' },
  { name: 'Kiribati', value: 'Kiribati' },
  { name: 'St.Kitts And Nevis', value: 'St.Kitts And Nevis' },
  { name: 'The Republic Of Korea', value: 'The Republic Of Korea' },
  { name: 'Kuwait', value: 'Kuwait' },
  { name: 'Laos', value: 'Laos' },
  { name: 'Lebanon', value: 'Lebanon' },
  { name: 'Liberia', value: 'Liberia' },
  { name: 'Libyan Arab Jamahiriya', value: 'Libyan Arab Jamahiriya' },
  { name: 'Saint Lucia', value: 'Saint Lucia' },
  { name: 'Liechtenstein', value: 'Liechtenstein' },
  { name: 'Sri Lanka', value: 'Sri Lanka' },
  { name: 'Lesotho', value: 'Lesotho' },
  { name: 'Lithuania', value: 'Lithuania' },
  { name: 'Luxembourg', value: 'Luxembourg' },
  { name: 'Latvia', value: 'Latvia' },
  { name: 'Macao', value: 'Macao' },
  { name: 'Saint Martin (French Part)', value: 'Saint Martin (French Part)' },
  { name: 'Morocco', value: 'Morocco' },
  { name: 'Monaco', value: 'Monaco' },
  { name: 'Moldova, Republic Of', value: 'Moldova, Republic Of' },
  { name: 'Madagascar', value: 'Madagascar' },
  { name: 'Maldives', value: 'Maldives' },
  { name: 'Mexico', value: 'Mexico' },
  { name: 'Marshall Islands', value: 'Marshall Islands' },
  {
    name: 'Macedonia, The Former Yugoslav Republic Of',
    value: 'Macedonia, The Former Yugoslav Republic Of',
  },
  { name: 'Mali', value: 'Mali' },
  { name: 'Malta', value: 'Malta' },
  { name: 'Myanmar', value: 'Myanmar' },
  { name: 'Montenegro', value: 'Montenegro' },
  { name: 'Mongolia', value: 'Mongolia' },
  { name: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
  { name: 'Mozambique', value: 'Mozambique' },
  { name: 'Mauritania', value: 'Mauritania' },
  { name: 'Montserrat', value: 'Montserrat' },
  { name: 'Martinique', value: 'Martinique' },
  { name: 'Mauritius', value: 'Mauritius' },
  { name: 'Malawi', value: 'Malawi' },
  { name: 'Malaysia', value: 'Malaysia' },
  { name: 'Mayotte', value: 'Mayotte' },
  { name: 'Namibia', value: 'Namibia' },
  { name: 'New Caledonia', value: 'New Caledonia' },
  { name: 'Niger', value: 'Niger' },
  { name: 'Norfolk Island', value: 'Norfolk Island' },
  { name: 'Nigeria', value: 'Nigeria' },
  { name: 'Nicaragua', value: 'Nicaragua' },
  { name: 'Niue', value: 'Niue' },
  { name: 'Netherlands', value: 'Netherlands' },
  { name: 'Norway', value: 'Norway' },
  { name: 'Nepal', value: 'Nepal' },
  { name: 'Nauru', value: 'Nauru' },
  { name: 'New Zealand', value: 'New Zealand' },
  { name: 'Oman', value: 'Oman' },
  { name: 'Pakistan', value: 'Pakistan' },
  { name: 'Panama', value: 'Panama' },
  { name: 'Pitcairn', value: 'Pitcairn' },
  { name: 'Peru', value: 'Peru' },
  { name: 'Philippines', value: 'Philippines' },
  { name: 'Palau', value: 'Palau' },
  { name: 'Papua New Guinea', value: 'Papua New Guinea' },
  { name: 'Poland', value: 'Poland' },
  { name: 'Puerto Rico', value: 'Puerto Rico' },
  { name: 'Democ.Peoples Rep.Of Korea', value: 'Democ.Peoples Rep.Of Korea' },
  { name: 'Portugal', value: 'Portugal' },
  { name: 'Paraguay', value: 'Paraguay' },
  {
    name: 'Palestinian Territory, Occupied',
    value: 'Palestinian Territory, Occupied',
  },
  { name: 'French Polynesia', value: 'French Polynesia' },
  { name: 'Qatar', value: 'Qatar' },
  { name: 'Reunion', value: 'Reunion' },
  { name: 'Romania', value: 'Romania' },
  { name: 'Russian Federation (Ussr)', value: 'Russian Federation (Ussr)' },
  { name: 'Rwanda', value: 'Rwanda' },
  { name: 'Saudi Arabia', value: 'Saudi Arabia' },
  { name: 'Sudan', value: 'Sudan' },
  { name: 'Senegal', value: 'Senegal' },
  { name: 'Singapore', value: 'Singapore' },
  {
    name: 'South Georgia And The South Sandwich Island',
    value: 'South Georgia And The South Sandwich Island',
  },
  { name: 'St. Helena', value: 'St. Helena' },
  {
    name: 'Svalbard And Jan Mayen Islands',
    value: 'Svalbard And Jan Mayen Islands',
  },
  { name: 'Solomon Islands', value: 'Solomon Islands' },
  { name: 'Sierra Leone', value: 'Sierra Leone' },
  { name: 'El Salvador', value: 'El Salvador' },
  { name: 'San Marino', value: 'San Marino' },
  { name: 'Somalia', value: 'Somalia' },
  { name: 'St. Pierre And Miquelon', value: 'St. Pierre And Miquelon' },
  { name: 'Serbia & Montenegro', value: 'Serbia & Montenegro' },
  { name: 'South Sudan', value: 'South Sudan' },
  { name: 'Sao Tome And Principe', value: 'Sao Tome And Principe' },
  { name: 'Suriname', value: 'Suriname' },
  { name: 'Slovak Republic', value: 'Slovak Republic' },
  { name: 'Slovenia', value: 'Slovenia' },
  { name: 'Sweden', value: 'Sweden' },
  {
    name: 'Eswatini, Kingdom Of (Swaziland)',
    value: 'Eswatini, Kingdom Of (Swaziland)',
  },
  { name: 'Sint Maarten (Dutch Part)', value: 'Sint Maarten (Dutch Part)' },
  { name: 'Seychelles', value: 'Seychelles' },
  { name: 'Syrian Arab Republic', value: 'Syrian Arab Republic' },
  { name: 'Turks And Caicos Islands', value: 'Turks And Caicos Islands' },
  { name: 'Chad', value: 'Chad' },
  { name: 'Togo', value: 'Togo' },
  { name: 'Thailand', value: 'Thailand' },
  { name: 'Tajikistan', value: 'Tajikistan' },
  { name: 'Tokelau', value: 'Tokelau' },
  { name: 'Turkmenistan', value: 'Turkmenistan' },
  { name: 'Timor-Leste', value: 'Timor-Leste' },
  { name: 'Tonga', value: 'Tonga' },
  { name: 'Trinidad And Tobago', value: 'Trinidad And Tobago' },
  { name: 'Tunisia', value: 'Tunisia' },
  { name: 'Turkiye', value: 'Turkiye' },
  { name: 'Tuvalu', value: 'Tuvalu' },
  { name: 'Taiwan', value: 'Taiwan' },
  { name: 'Tanzania United Republic', value: 'Tanzania United Republic' },
  { name: 'Uganda', value: 'Uganda' },
  { name: 'Ukraine', value: 'Ukraine' },
  {
    name: 'United States Minor Outlying Islands',
    value: 'United States Minor Outlying Islands',
  },
  { name: 'Uruguay', value: 'Uruguay' },
  { name: 'United States Of America', value: 'United States Of America' },
  { name: 'Uzbekistan', value: 'Uzbekistan' },
  {
    name: 'Vatican City State (Holy See)',
    value: 'Vatican City State (Holy See)',
  },
  {
    name: 'Saint Vincent And Grenadines',
    value: 'Saint Vincent And Grenadines',
  },
  { name: 'Venezuela', value: 'Venezuela' },
  { name: 'Virgin Islands(British)', value: 'Virgin Islands(British)' },
  { name: 'Virgin Islands(Us)', value: 'Virgin Islands(Us)' },
  { name: 'Vietnam', value: 'Vietnam' },
  { name: 'Vanuatu', value: 'Vanuatu' },
  { name: 'Wallis And Futuna Islands', value: 'Wallis And Futuna Islands' },
  { name: 'Samoa', value: 'Samoa' },
  { name: 'Kosovo', value: 'Kosovo' },
  { name: 'Yemen', value: 'Yemen' },
  { name: 'South Africa', value: 'South Africa' },
  { name: 'Zambia', value: 'Zambia' },
  { name: 'Zimbabwe', value: 'Zimbabwe' },
];
